import { BaseShutterProductType } from '../constants/productTypes';
import { ProductBuilderMachineContext } from '../types';

export const isShutters = ({ products }: ProductBuilderMachineContext) => {
  const shutterBaseProductType: BaseShutterProductType =
    'Tecwood Plantation Shutter';
  return products[0].type.includes(shutterBaseProductType);
};
